export default class GridItemElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('grid-item', GridItemElement);